<template>
  <h1>Events For Good</h1>
  <div class="events">
    <EventCard v-for="event in events" :key="event.id" :event="event" />
    <div class="pagination">
      <router-link
        :to="{ name: 'EventList', query: { page: this.page - 1 } }"
        rel="prev"
        v-if="page !== 1"
      >
        &#60; Previous
      </router-link>
      <router-link
        :to="{ name: 'EventList', query: { page: this.page + 1 } }"
        rel="next"
        v-if="hasNextPage"
      >
        Next &#62;
      </router-link>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import EventCard from '@/components/EventCard';
import store from '@/store';

export default {
  name: 'EventList',
  props: ['page'],
  components: {
    EventCard,
  },
  beforeRouteEnter(routeTo, routeFrom, next) {
    console.log('beforeRouteEnter');
    store
      .dispatch('fetchEvents', {
        page: parseInt(routeTo.query.page) || 1,
      })
      .then(() => {
        next();
      })
      .catch(() => {
        next({
          name: 'NetworkError',
        });
      });
  },
  beforeRouteUpdate(routeTo) {
    return store
      .dispatch('fetchEvents', {
        page: parseInt(routeTo.query.page) || 1,
      })
      .then(() => {})
      .catch(() => {
        return { name: 'NetworkError' };
      });
  },
  computed: {
    events() {
      return store.state.events;
    },
    hasNextPage() {
      let totalPages = Math.ceil(store.state.eventTotal / 10);
      return this.page < totalPages;
    },
  },
};
</script>
<style scoped>
.events {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.pagination {
  display: flex;
  width: 290px;
}
.pagination a {
  flex: 1;
  text-decoration: none;
  color: #2c3e50;
}

#page-prev {
  text-align: left;
}

#page-next {
  text-align: right;
}
</style>
